<template>
  <div class="max-w-md mx-auto my-3">
    <div class="text-center p-2">
      <button
        class="px-3 py-2 text-white bg-pink-500 border border-pink-600 rounded hover:bg-pink-600"
        @click.prevent="addTransaction"
      >Add transaction</button>
    </div>

    <div v-if="transactions.length > 0">
      <div class="text-center my-2">
        <p class="mb-3">
          <span class="text-pink-600">Period</span>
          <br />
          {{ startDate | formatDate }} - {{ endDate | formatDate }}
        </p>
        <p class="mb-5">
          <span class="text-pink-600">Number of transactions</span>
          <br />
          {{ numberOfTransactions }} (In: {{ incomeTransactions }}, Exp: {{ expenseTransactions }})
        </p>
        <div class="flex justify-center content-center border-b border-pink-500 w-3/5 mx-auto mb-3">
          <p class="mb-3 mr-10">
            <span class="text-pink-600">
              Income
              <font-awesome-icon icon="arrow-alt-circle-down" class="ml-1 text-green-400" />
            </span>
            <br />
            £{{ income }}
          </p>
          <p class="mb-3">
            <span class="text-pink-600">
              Expense
              <font-awesome-icon icon="arrow-alt-circle-up" class="ml-1 text-red-500" />
            </span>
            <br />
            £{{ outcome }}
          </p>
        </div>
        <p class="mb-3">
          <span class="text-pink-600">Total</span>
          <br />
          £{{ total }}
        </p>
      </div>

      <div class="text-center my-6" v-if="!loading && transactions.length > 0">
        <router-link
          class="px-3 py-2 text-white bg-blue-500 border border-blue-600 rounded"
          to="/print"
        >Print</router-link>
      </div>

      <div class="text-center mb-4">
        <a
          href="#"
          class="mr-4 text-orange-600"
          :class="{ 'border-b border-orange-600':filter === 'all' }"
          @click.prevent="changeFilter('all')"
        >All</a>
        <a
          href="#"
          class="mr-4 text-orange-600"
          :class="{ 'border-b border-orange-600':filter === 'income' }"
          @click.prevent="changeFilter('income')"
        >Income</a>
        <a
          href="#"
          class="text-orange-600"
          :class="{ 'border-b border-orange-600':filter === 'expense' }"
          @click.prevent="changeFilter('expense')"
        >Expense</a>
      </div>

      <Transaction
        v-for="transaction in paginatedTransactions"
        :key="transaction.id"
        :id="transaction.id"
        :amount="transaction.amount"
        :date="transaction.date"
        :description="transaction.description"
        :type="transaction.type"
        :open="transaction.open"
      />

      <BasePagination
        v-if="!loading && transactions.length > 0"
        :currentPage="currentPage"
        :pageCount="pageCount"
        @nextPage="pageChangeHandle('next')"
        @previousPage="pageChangeHandle('previous')"
        @loadPage="pageChangeHandle"
      ></BasePagination>
    </div>

    <div v-if="!loading && transactions.length === 0" class="text-center mt-6">
      <p class="mb-3 text-pink-600">No transactions yet :(</p>
    </div>
  </div>
</template>

<script>
import Transaction from "@/components/Transaction.vue";
import BasePagination from "@/components/pagination/BasePagination.vue";
import store from "@/store/index.js";

export default {
  name: "transaction-list",
  static: {
    visibleItemsPerPageCount: 30
  },
  data() {
    return {
      currentPage: 1,
      filter: "all"
    };
  },
  computed: {
    transactions() {
      return this.$store.getters.transactions;
    },
    paginatedTransactions() {
      if (this.$store.getters.paginatedTransactions.length > 0) {
        if (this.filter === "all") {
          return this.$store.getters.paginatedTransactions;
        } else if (this.filter === "income") {
          return this.$store.getters.paginatedTransactions.filter(
            obj => obj.type === "income"
          );
        } else if (this.filter === "expense") {
          return this.$store.getters.paginatedTransactions.filter(
            obj => obj.type === "outcome"
          );
        }
      } else {
        return [];
      }
    },
    numberOfTransactions() {
      return this.$store.getters.numberOfTransactions;
    },
    incomeTransactions() {
      if (this.$store.getters.paginatedTransactions.length > 0) {
        return this.$store.getters.paginatedTransactions.filter(
          obj => obj.type === "income"
        ).length;
      } else {
        return 0;
      }
    },
    expenseTransactions() {
      if (this.$store.getters.paginatedTransactions.length > 0) {
        return this.$store.getters.paginatedTransactions.filter(
          obj => obj.type === "outcome"
        ).length;
      } else {
        return 0;
      }
    },
    income() {
      return this.$store.getters.income;
    },
    outcome() {
      return this.$store.getters.outcome;
    },
    total() {
      return this.income - this.outcome;
    },
    loading() {
      return this.$store.getters.loading;
    },
    pageCount() {
      return this.transactions
        ? Math.ceil(
            this.transactions.length /
              this.$options.static.visibleItemsPerPageCount
          )
        : 0;
    },
    startDate() {
      return this.$store.getters.startDate;
    },
    endDate() {
      return this.$store.getters.endDate;
    }
  },
  methods: {
    addTransaction() {
      this.$router.push("/add-transaction");
    },
    changeFilter(val) {
      this.filter = val;
    },
    pageChangeHandle(value) {
      switch (value) {
        case "next":
          this.currentPage += 1;
          break;
        case "previous":
          this.currentPage -= 1;
          break;
        default:
          this.currentPage = value;
      }

      // console.log(this.currentPage);

      // dispatch action with currentPage and pageCount to get correct transactions
      // then it should be according to computed prop to render correct transactions
      store.dispatch("getPaginatedTransactions", {
        currentPage: this.currentPage,
        visibleItemsPerPageCount: this.$options.static.visibleItemsPerPageCount
      });
    }
  },
  mounted() {
    store.dispatch(
      "setInitialItemsPerPage",
      this.$options.static.visibleItemsPerPageCount
    );
  },
  filters: {
    formatDate(isoDate) {
      if (!isoDate) {
        return "";
      }

      return new Date(isoDate).toLocaleDateString();
    }
  },
  components: {
    Transaction,
    BasePagination
  }
};
</script>

<style lang="scss" scoped>
</style>